import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Icon from "module-common/Icon";

export default class Tab extends Component {
  static propTypes = {
    name: PropTypes.string,
    total: PropTypes.number,
    replied: PropTypes.number,
    notification: PropTypes.bool,
    sortAsc: PropTypes.bool,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
    onSortClick: PropTypes.func
  };
  static defaultProps = {
    name: "Case",
    total: 0,
    replied: -1,
    notification: false,
    sortAsc: false,
    selected: false
  };

  render() {
    const {
      name,
      total,
      replied,
      notification,
      sortAsc,
      selected,
      onClick
    } = this.props;

    let num;
    if (replied >= 0) {
      num = `${replied}/${total}`;
    } else {
      num = `${total}`;
    }

    let icon;
    if (notification) {
      icon = <TabIcon mode="auto" name="notification" />;
    } else if (selected) {
      if (sortAsc) {
        icon = (
          <TabIcon mode="auto" name="ascending" onClick={this.onSortClick} />
        );
      } else {
        icon = (
          <TabIcon mode="auto" name="descending" onClick={this.onSortClick} />
        );
      }
    }

    return (
      <Wrapper selected={selected} onClick={onClick}>
        <Title selected={selected}>{name}</Title>
      </Wrapper>
    );
  }

  onSortClick = () => {
    const { sortAsc, onSortClick } = this.props;
    if (onSortClick) onSortClick(!sortAsc);
  };
}

const Wrapper = styled.div`
  flex: 1;
  height: 44px;
  position: relative;
  transition: 0.3s;
  ${props => props.onClick && "cursor: pointer"};
  &:hover {
    background-color: ${props => props.theme.panelBackground};
  }
  background-color: ${props =>
    props.selected ? props.theme.panelBackground : props.theme.unselectedTab};
`;
const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  text-align: center;
  white-space: nowrap;
  font-size: 1rem;
  line-height: 1;
  color: ${props =>
    props.selected ? props.theme.headerTitle : props.theme.uiText};
  ${props => props.selected && "font-weight:bold"};
`;
const TabIcon = styled(Icon)`
  position: absolute;
  right: 14px;
  top: 0px;
  bottom: 0px;
  margin: auto;
`;



// WEBPACK FOOTER //
// ./src/module-schedule/header/Tab.js